export const ANALYTICS_CONSENT_KEY = 'ac_cookie_consent';

export function globalPrivacyControlActive(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
}

export function hasAnalyticsConsent(): boolean {
  if (typeof window === 'undefined') return false;
  if (globalPrivacyControlActive()) return false;
  try { return window.localStorage.getItem(ANALYTICS_CONSENT_KEY) === 'accepted'; } catch { return false; }
}

export function analyticsSurfaceAllowed(path = window.location.pathname): boolean {
  return !/^\/(?:admin|api|account|app|auth|oauth|login|claim)(?:[/.]|$)/i.test(path)
    && !['preview', 'analyticsPreview', 'onboardingPreview'].some((name) => new URLSearchParams(window.location.search).get(name) === '1');
}
